// ----------------------------------------------------------------------

export default function Container() {
  return {
    MuiContainer: {
      defaultProps: {
        maxWidth: false,
      },
      styleOverrides: {
        root: {
          width: '100%',
        },
        maxWidthXs: {
          maxWidth: 'none !important',
        },
        maxWidthSm: {
          maxWidth: 'none !important',
        },
        maxWidthMd: {
          maxWidth: 'none !important',
        },
        maxWidthLg: {
          maxWidth: 'none !important',
        },
        maxWidthXl: {
          maxWidth: 'none !important',
        },
      }
    }
  };
}
